import React from 'react';
import MobileDownloadLink from '../../../components/MobileDownloadLink';

/**
 * Founding-members promo section (#founding).
 * The "first 1,000 members" launch offer.
 *
 * data-rv="up" marks it for the reveal-on-scroll IntersectionObserver
 * (wired later, in the LandingPage effect). It renders fine without it.
 */

const IOS_URL = 'https://apps.apple.com/us/app/kachng-digital-receipt/id6502332854';
const ANDROID_URL = 'https://play.google.com/store/apps/details?id=com.Gibbas.KACHNG';

const mono = "'JetBrains Mono', ui-monospace, monospace";

export default function Founding({ mobile = false }) {
  return (
    <section id="founding">
      <div
        style={{
          maxWidth: 'var(--max-width)',
          margin: '0 auto',
          boxSizing: 'border-box',
          padding: '0 clamp(20px,5vw,56px) clamp(40px,5vw,64px)',
        }}
      >
        <div className="founding-card"
          data-rv="up"
          style={{
            border: '1px solid rgba(0,230,118,0.24)',
            borderRadius: '24px',
            background: 'radial-gradient(120% 150% at 10% 0%, #12281B 0%, #0C120E 62%)',
            boxShadow: '0 24px 64px rgba(0,0,0,0.5), inset 0 1px 0 rgba(0,230,118,0.14)',
            padding: 'clamp(28px,4vw,52px) clamp(24px,4vw,56px)',
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 'clamp(28px,4vw,56px)',
            boxSizing: 'border-box',
          }}
        >
          <div className="founding-copy" style={{ flex: '1 1 480px', minWidth: 'min(100%,320px)' }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                flexWrap: 'wrap',
                marginBottom: '20px',
              }}
            >
              <div
                style={{
                  fontFamily: mono,
                  color: 'var(--kachng-green)',
                  fontSize: '12px',
                  letterSpacing: '0.22em',
                  textTransform: 'uppercase',
                  fontWeight: 500,
                }}
              >
                The Founding 1,000
              </div>
              <span
                style={{
                  width: '4px',
                  height: '4px',
                  borderRadius: '50%',
                  background: '#2E332E',
                  flex: 'none',
                }}
              />
              <div
                style={{
                  fontFamily: mono,
                  color: 'var(--text-muted)',
                  fontSize: '12px',
                  letterSpacing: '0.14em',
                  textTransform: 'uppercase',
                }}
              >
                iOS | Android Launch 
              </div>
            </div>

            <h2
              style={{
                margin: '0 0 16px',
                fontSize: 'clamp(28px,3.2vw,42px)',
                fontWeight: 800,
                letterSpacing: '-0.025em',
                lineHeight: 1.05,
                textWrap: 'balance',
              }}
            >
              Rebuild your last 30 days of spending.
            </h2>

            <p
              style={{
                margin: 0,
                fontSize: '16px',
                lineHeight: 1.6,
                color: 'var(--text-300)',
                maxWidth: '62ch',
              }}
            >
              {mobile ? "Forward up to a month of digital receipts to rebuild your purchase history and unlock spending intelligence." : <>The first 1,000 KACHNG members can forward up to one month of digital receipts.
              KACHNG will reconstruct their recent purchase history, unlock their spending
              intelligence, and award points instantly.</>}
            </p>
          </div>

          <div className="founding-actions"
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              gap: '12px',
              flex: 'none',
            }}
          >
            {mobile ? <MobileDownloadLink source="founding" /> : <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
              <a
                href={IOS_URL}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  background: 'var(--kachng-green)',
                  color: 'var(--bg-ink)',
                  fontWeight: 700,
                  fontSize: '16px',
                  padding: '16px 32px',
                  borderRadius: '8px',
                  minHeight: '44px',
                  boxSizing: 'border-box',
                  whiteSpace: 'nowrap',
                }}
              >
                Download for iOS
              </a>
              <a
                href={ANDROID_URL}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  background: 'var(--green-accent-bg)',
                  color: 'var(--kachng-green)',
                  fontWeight: 700,
                  fontSize: '16px',
                  padding: '16px 32px',
                  borderRadius: '8px',
                  minHeight: '44px',
                  boxSizing: 'border-box',
                  whiteSpace: 'nowrap',
                }}
                onMouseEnter={(e) => (e.currentTarget.style.background = 'var(--green-accent-bg-hi)')}
                onMouseLeave={(e) => (e.currentTarget.style.background = 'var(--green-accent-bg)')}
              >
                Download for Android
              </a>
            </div>}
            <span style={{ fontSize: '14px', fontWeight: 600, color: 'var(--kachng-green)', padding: '8px 14px', borderRadius: '6px', border: '1px solid rgba(0,230,118,.25)', background: 'rgba(0,230,118,.06)' }}>
              Available to the first 1,000 members.
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}